import React from 'react';
import { Helmet } from 'react-helmet-async';
import IntroductionTabs from '../../IntroductionTabs';
import BusinessDepartmentShowcase from './BusinessDepartmentShowcase';
import './businessfield.css';

const BusinessFinancePage = () => {
  const canonical = 'https://www.xn--o39ap7bo6pk0bo2x.com/business/finance';
  const title = '총무부 - 주식회사 가까운물류';
  const desc = '회사의 전반적인 행정 및 재무 업무를 담당합니다.';

  const cards = [
    { title: '정산 및 지출결의 관리', description: '정확한 정산과 지출 관리로 운영 안정성 확보' },
    { title: '증빙 및 전표 관리', description: '회계/증빙 문서 체계화로 투명성 강화' },
    { title: '인사 관리', description: '인력 운영 및 조직 관리 지원' },
    { title: '시설 관리', description: '업무 환경과 시설 운영 관리' },
  ];

  return (
    <div className="business-page">
      <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={canonical} />
        <meta name="description" content={desc} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content="주식회사 가까운물류" />
        <meta property="og:image" content="https://www.xn--o39ap7bo6pk0bo2x.com/og-1200x630.png?v=1" />
      </Helmet>

      <IntroductionTabs type="business">
        <div tabId="finance" className="business-content">
          <BusinessDepartmentShowcase
            headline={
              <>
                <span className="hl">총무부</span>는 회사 운영의 기반이 되는 행정과 재무 업무를 담당하며
                <br />
                전사 운영을 안정적으로 지원합니다.
              </>
            }
            pill="운영 지원 조직"
            pillDescription="정산·증빙·인사·시설 등 운영 전반을 체계적으로 관리합니다."
            featureTitle="총무부의 특성"
            featureEmphasis="정확성과 체계성을 바탕으로, 전사 운영이 흔들림 없이 돌아가도록 지원합니다."
            featureDescription="업무 표준화와 문서/프로세스 관리를 통해 효율적인 운영 환경을 제공합니다."
            centerLabel="총무부"
            cards={cards}
          />
        </div>
      </IntroductionTabs>
    </div>
  );
};

export default BusinessFinancePage;
